import { connect } from 'react-redux';
import { Currency } from '~/Api/Currency';
import config from '~/config';
import { fetchCurrenciesIfNeeded as fetchCurrencies, State as CurrencyState } from '~/Currency';

import SelectPopover, { PriceType } from './SelectPopover';

interface Props {
	currencies: Currency[] | null;
	isFetchingCurrencies: boolean;
	priceTypes: PriceType[];
}

function mapStateToProps(state: { currency: CurrencyState }, props: { currencies: Currency[] | null }): Props {
	const { currency } = state;
	return {
		currencies: props.currencies ?? currency.currencies,
		isFetchingCurrencies: currency.isFetching,
		priceTypes: config.product.priceTypes as PriceType[],
	};
}

const actions: { onFetch: typeof fetchCurrencies } = {
	onFetch: fetchCurrencies,
};

export default connect(mapStateToProps, actions)(SelectPopover);
